
import * as React from 'react'
import {Container} from 'react-bootstrap';
import '../../AdminPage.scss'
import '../AdminAdd.scss';

const AdminAddArticle = () => {

    return (
        <Container fluid className='admin-decorator'>
            <div>
                <div className='admin-decorator__title'>
                    Новая статья
                </div>
                <div className="admin__new-article admin__temp">
                    Раздел находится в разработке
                </div>
            </div>
        </Container>
    )
}

export default AdminAddArticle;